:host {
  font-family: sans-serif;
  font-size: 18px;
}

.sellalong-powered-by-brand-link {
  font-family: var(--sellalong-heading-font, serif);
  text-decoration: none;
  color: #000;
  margin-right: 0.25em;
}

.sellalong-powered-by-logo {
  height: 20px;
  margin-top: 5px;
  vertical-align: top;
}

.sellalong-powered-by-brand {
  color: #bcbdc0;
  font-family: var(--sellalong-control-font, sans-serif);
  font-size: 20px;
  font-weight: bold;
  text-decoration: none;
}

.sellalong-powered-by-brand > b {
  color: #db6a42;
}

.sellalong-powered-by-link {
  font-family: var(--sellalong-control-font, sans-serif);
  font-size: 18px;
  letter-spacing: 0.5px;
  margin-left: 0.25em;
}
